/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  notificationsRequest: null,
  notificationsSuccess: ['data'],

  updateNotificationsRequest: ['data'],
  updateNotificationsSuccess: ['data'],

  notificationsReset: null,

  notificationsFetchingReset: null,
})

export const NotificationsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: false,
})

/* ------------- Selectors ------------- */
export const NotificationsSelectors = {
  getData: state => state.notifications.data,
}

export const notificationsRequest = (state, {}) => {
  return state.merge({fetching: true})
}
export const notificationsSuccess = (state, {data}) => {
  return state.merge({fetching: false, data})
}

export const updateNotificationsRequest = (state, {data}) => {
  return state.merge({fetching: true})
}
export const updateNotificationsSuccess = (state, {data}) => {
  let newBlock = state.data[data.block].map(el => (el.id === data.id ? {...el, selected: data.selected} : {...el}))

  return state.merge({fetching: false, data: {...state.data, [data.block]: [...newBlock]}})
}

export const notificationsReset = state => {
  return INITIAL_STATE
}

export const notificationsFetchingReset = state => {
  return state.merge({fetching: false})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.NOTIFICATIONS_REQUEST]: notificationsRequest,
  [Types.NOTIFICATIONS_SUCCESS]: notificationsSuccess,
  [Types.NOTIFICATIONS_RESET]: notificationsReset,

  [Types.UPDATE_NOTIFICATIONS_REQUEST]: updateNotificationsRequest,
  [Types.UPDATE_NOTIFICATIONS_SUCCESS]: updateNotificationsSuccess,

  [Types.NOTIFICATIONS_FETCHING_RESET]: notificationsFetchingReset,
})
